@if(user){
<nav class="navbar navbar-expand-lg  m-0 p-0 ">

  <!-- <div class="sidebar-logo px-2">
    <a class="navbar-brand pe-3" style="cursor: pointer" routerLink="/">
      <img src="agrify-ai-blue.png" class="img-fluid" alt="Agrify AI Logo" />
    </a>
  </div> -->

  <div class="quotes-header d-flex align-items-center justify-content-between px-3 w-100">
    <div class="d-flex align-items-center gap-2 ps-3">
      <i class="bi bi-arrow-left fs-3 fw-bold back-icon" style="cursor: pointer;" *ngIf="navState.showBackButton$ | async" (click)="goBack()"></i>
      <h1 class="m-0 header-title">{{ navState.currentTitle$ | async }}</h1>
    </div>

    <div class="d-flex align-items-center gap-3 header-controls d-none d-lg-flex">
      <div class="search-container">
        <i class="bi bi-search search-icon-inner"></i>
        <input type="text" class="form-control search-input-rounded" placeholder="Ask Anything ..." (click)="navigateToTradeGPT()">
      </div>
      <div class="header-icon-btn" (click)="toggleHistory()">
       <img src="/icons/tradegpt-header.svg">
        <span class="notification-dot"></span>
      </div> 
    <div class="header-icon-btn" (click)="viewHelp()">
        <i class="bi bi-question-circle"></i>
      </div>
    </div>
  </div>
</nav>


}